import { render, staticRenderFns } from "./lawsuit-follow-trial.vue?vue&type=template&id=0811b186&scoped=true"
import script from "./lawsuit-follow-trial.vue?vue&type=script&lang=ts"
export * from "./lawsuit-follow-trial.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0811b186",
  null
  
)

export default component.exports